import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-3" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        <FadeIn className="bg-surface/70 border border-accent/20 rounded-2xl p-6 md:p-10 text-center relative overflow-hidden shadow-xl" data-id="element-77">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-accent" data-id="element-78" />

          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-accent/10 mb-4" data-id="element-79">
            <ShieldCheck size={32} className="text-accent" data-id="element-80" />
          </div>

          <h2 className="font-display text-xl md:text-2xl font-bold mb-4 text-accent" data-id="element-81">
            Garantía de 7 días.
          </h2>

          <div className="space-y-3 text-sm md:text-base text-ink/80 max-w-2xl mx-auto leading-relaxed" data-id="element-82">
            <p data-id="element-83">Revisás los 6 tomos y los bonos con tranquilidad.</p>
            <p className="font-bold text-ink" data-id="element-84">
              Si dentro de los 7 días sentís que el material no era lo que
              esperabas, te devolvemos el 100%.
            </p>
            <p className="text-muted" data-id="element-85">Sin trámites complicados.</p>
          </div>
        </FadeIn>
      </div>
    </section>;
}